/**
 * 系统-账号管理
 */
import { addAccountDialog, editAccountDialog, accountColumnAffiliation } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/base_user/admin/account/list'
      },
      add: {
        label: '新建账号',
        api: '/base_user/admin/account/create',
        dialog: addAccountDialog(),
        successMessage: '创建成功'
      },
      edit: {
        label: '编辑',
        api: '/base_user/admin/account/update',
        dialog: editAccountDialog(),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/base_user/admin/account/delete',
        payload: {
          userCode: '${data.row.userCode}'
        },
        message: '确认删除该账号？'
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 120,
      items: [
        { type: 'input', prop: 'keyword', label: '账号名称/手机号', span: 8 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 140,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      columns: [
        { label: '账号名称', prop: 'userName', minWidth: 140 },
        { label: '手机号', prop: 'mobile', minWidth: 120 },
        {
          label: '归属',
          prop: 'belongType',
          minWidth: 100,
          formatter: accountColumnAffiliation
        },
        { label: '角色', prop: 'roleName', minWidth: 120 },
        { label: '供应商组织编码', prop: 'supplierOrgCode', minWidth: 160 },
        {
          label: '创建时间',
          prop: 'gmtCreate',
          minWidth: 160,
          formatter: (row: any) =>
            row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
        }
      ]
    }
  }
}
